import React from 'react';

export default function ReminderExpired() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Reminder Expired</h1>
      <p className="text-gray-500">Halaman Reminder Expired</p>
    </div>
  );
}
